import { createAction } from 'redux-actions';
import {
  VALID_USER,
  VALID_HEAT_TREATMENT,
  VALID_MATERIAL,
  VALID_CLIENT,
  VALID_PRODUCT,
  VALID_TEAM,
  VALID_LOCATION,
  VALID_LOCATIONS_PERSON,
  VALID_ORDER,
  VALID_SCHEDULE,
  VALID_TASK,
  VALID_TASKS_MEMO,
  VALID_COMMENT,
  VALID_DELIVERY_OPTION
} from '../action_types';

export const validations = {
  user:           createAction(VALID_USER),
  heat_treatment: createAction(VALID_HEAT_TREATMENT),
  material:       createAction(VALID_MATERIAL),
  client:         createAction(VALID_CLIENT),
  product:        createAction(VALID_PRODUCT),
  team:           createAction(VALID_TEAM),
  location:       createAction(VALID_LOCATION),
  locations_person: createAction(VALID_LOCATIONS_PERSON),
  order:          createAction(VALID_ORDER),
  schedule:       createAction(VALID_SCHEDULE),
  task:           createAction(VALID_TASK),
  tasks_memo:     createAction(VALID_TASKS_MEMO),
  comment:        createAction(VALID_COMMENT),
  delivery_option: createAction(VALID_DELIVERY_OPTION)
};
